<template>
  <div class="product-config-wrap">
    <el-row
      class="my-transfer"
      :gutter="20"
    >
      <el-col
        :md="24"
        :lg="12"
        style="border-right:solid 1px #e5e5e5"
      >
        <el-divider content-position="center">关键控制点设置</el-divider>
        <el-transfer
          v-model="cruxVal"
          :data="cruxData"
          :titles="['可选关键控制点', '已选关键控制点']"
          @change="(val) => handleChange(this.cruxData, val, 'point')"
        ></el-transfer>
      </el-col>
      <el-col
        :md="24"
        :lg="12"
      >
        <el-divider content-position="center">检验项设置</el-divider>
        <el-transfer
          v-model="checkVal"
          :data="checkData"
          :titles="['可选检验项', '已选检验项']"
          @change="(val) => handleChange(this.checkData, val, 'check')"
        ></el-transfer>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mappingPoint, mappingCheck } from '@/api/mapping'
import { NOOP } from '@/utils/shared'

const transformData = (data, namespace) =>
  data.map(_ => ({
    key: _.id,
    label: _[`${namespace}Name`]
  }))

const diffIds = (source, finds) => {
  const ids = []

  source
    .map(_ => _.key)
    .forEach(key => {
      if (finds.indexOf(key) === -1) {
        ids.push(key)
      }
    })

  return ids
}

export default {
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      cruxData: [],
      cruxVal: [],
      checkVal: [],
      checkData: []
    }
  },
  created() {
    this.initMappingPointDataList()
  },
  methods: {
    initMappingPointDataList() {
      const id = this.id

      if (id === null || id === undefined) return

      mappingPoint.get(id).then(res => {
        const {
          controlCoints = [],
          productControlCoints = []
        } = res.data

        this.cruxData = [
          ...transformData(controlCoints, 'point'),
          ...transformData(productControlCoints, 'controlPoint')
        ]

        this.cruxVal = productControlCoints.map(_ => _.id)
      })

      mappingCheck.get(id).then(res => {
        const {
          controlCoints = [],
          productControlCoints = []
        } = res.data

        this.checkData = [
          ...transformData(controlCoints, 'check'),
          ...transformData(productControlCoints, 'checkItems')
        ]

        this.checkVal = productControlCoints.map(_ => _.id)
      })
    },
    handleChange(source, val, type) {
      if (!source.length) return

      this.handleValSend(
        diffIds(source, val),
        val,
        type === 'point' ? mappingPoint : mappingCheck
      )
    },
    handleValSend(leftIds, val, mapping) {
      const __del = () => mapping.delete(this.id, leftIds)
      const __add = () => mapping.put(this.id, val)
      const lLen = leftIds.length
      const vLen = val.length

      lLen && vLen
        ? __del().then(() => __add())
        : !vLen
          ? __del()
          : !lLen
            ? __add()
            // 虽然不会发生 但是还是写一个空函数执行 (NOOP)
            : NOOP()
    }
  }
}
</script>
